<template>
    <div class="loading-placeholder">
      <div v-for="i in itemCount" :key="i" class="loading-item">
        <div class="loading-item-content">
          <div class="loading-image"></div>
          <div class="loading-text-container">
            <div class="loading-text loading-text-title"></div>
            <div class="loading-text loading-text-subtitle"></div>
            <div class="loading-text loading-text-price"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { defineProps } from 'vue';
  
  const props = defineProps({
    itemCount: {
      type: Number,
      default: 4,
    },
  });
  </script>
  
  <style scoped>
  .loading-placeholder {
    display: flex;
    flex-direction: column;
  }
  
  .loading-item {
    margin: 8px 0;
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #f5f5f5; /* Cor de fundo do placeholder */
    display: flex;
    align-items: center;
  }
  
  
  .loading-item-content {
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  .loading-image {
    width: 56px;
    height: 56px;
    margin-right: 16px;
    background-color: #eee;
    border-radius: 50%; /* Forma circular da imagem */
  }
  
  .loading-text-container {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  }
  
  .loading-text {
    margin-bottom: 4px;
    height: 8px;
    background-color: #eee;
    border-radius: 4px;
  }
  
  .loading-text-title {
    width: 60%; /* Ajusta a largura do placeholder */
  }
  
  .loading-text-subtitle {
    width: 80%; /* Ajusta a largura do placeholder */
  }
  
  .loading-text-price {
    width: 36px;
  }
  
  
  /* Adicione classes para o efeito shimmer usando vue-shimmer */
  .loading-item {
      animation: shimmer 1s infinite linear;
  }
  .loading-text {
      animation: shimmer 1s infinite linear;
  }
  
  @keyframes shimmer {
    0% {
      background-position: -100%;
    }
    100% {
      background-position: 100%;
    }
  }
  
  </style>
  